import { AlertCircle } from 'lucide-react';

interface Props {
  /** What category of data this page exposes (e.g. "members", "warehouse addresses"). */
  resourceLabel: string;
  /** Optional short why-it-matters line. */
  rationale?: string;
}

/**
 * Shown on cross-tenant resource pages when reached by PLATFORM_ADMIN via deep
 * link. The page itself is intentionally off the daily nav (see
 * `src/config/navigation.ts` — comment above `platformAdminNav`). The banner
 * makes the friction visible: routine browsing of customer data violates
 * data-minimization (GDPR Art. 5(1)(c), DPDP §5(c)) and the tenant-isolation
 * promise. ZAFROI ops should drill into a specific tenant from the Tenants
 * list, where the same data is scoped + audited per access.
 */
export function CrossTenantNotice({ resourceLabel, rationale }: Props) {
  return (
    <div className="rounded-md border border-warning/30 bg-warning/5 px-4 py-3">
      <div className="flex items-start gap-2.5 text-[12.5px] text-foreground">
        <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-warning" />
        <div className="space-y-1">
          <div className="font-medium">
            You are viewing {resourceLabel} across customer tenants.
          </div>
          <div className="text-muted-foreground">
            {rationale ?? `This data belongs to the customer; ZAFROI processes it on their behalf.`}{' '}
            Each access is logged. Prefer drilling into a specific tenant from
            <strong> Tenants</strong> — use this view only when a tenant cannot be identified up-front.
          </div>
        </div>
      </div>
    </div>
  );
}
